const sendMail = async(input) =>{
    const response = await fetch('https://portafolio-back-production.up.railway.app/sendMail',{
        method: "POST",
        body: JSON.stringify(input),
        headers: { "Content-Type": "application/json" },
    });

    const json = await response.json();
    return json
};

export default sendMail;
